module.exports = __webpack_public_path__ + "static/media/LK__Destination Pin A.a18c48c2.svg";